import {Component} from "react";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField as MTextField
} from "@material-ui/core";
import {
  Labeled, ReferenceManyField,
  refreshView as refreshViewAction,
  showNotification as showNotificationAction
} from "react-admin";
import $ from "jquery";
import {get} from "./authProvider";
import React from "react";
import { connect } from 'react-redux';
import { authCardStyle } from "./auth";

class SalesForceEnabler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      refreshPending: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.runSalesForceAssociation = this.runSalesForceAssociation.bind(this);
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    });
  }

  render() {
    let sfDataIds = (this.props.ids || []).filter(id => {
      return this.props.data[id].label === 'salesforce';
    });

    if (sfDataIds.length > 0) {
      return <div style={{marginBottom: '32px'}}>
        Currently associated.<br/>
        <Labeled label="Contact">
          <a href={`https://tpt.lightning.force.com/lightning/r/Contact/${this.props.data[sfDataIds[0]].data.id}/view`}
             target="_blank" rel="noopener noreferrer">{this.props.data[sfDataIds[0]].data.contact_cid}
          </a>
        </Labeled>
        <br/>
        <Labeled label="Account">
          <a href={`https://tpt.lightning.force.com/lightning/r/Account/${this.props.data[sfDataIds[0]].data.account_id}/view`}
             target="_blank" rel="noopener noreferrer">{this.props.data[sfDataIds[0]].data.account_id}
          </a>
        </Labeled>
        <br/>
        <Button variant="contained" color="primary" onClick={this.runSalesForceDissociation.bind(this)}>Dissociate</Button>
        &nbsp;
        <Button variant="contained" color="primary" onClick={!this.state.refreshPending ? this.pullSalesForceData.bind(this) : () => {}} disabled={this.state.refreshPending}>Refresh Data</Button>
      </div>;
    }

    return <div style={{marginBottom: '32px'}}>
      <div>Manually associate Salesforce contact</div>
      <Labeled label="Contact ID">
        <MTextField id="contact-id" onInput={this.handleChange} value={this.state.value}/>
      </Labeled>
      <Button variant="contained" color="primary" onClick={this.runSalesForceAssociation.bind(this)}>Associate</Button>
    </div>;
  }

  runSalesForceAssociation() {
    $.ajax('/api/v1/job/sf/manually-associate?mode=sync',
      {
        method: 'POST',
        data: {
          uuid: this.props.uuid,
          cid: this.state.value,
        },
        headers: {
          Authorization: 'Bearer ' + get()
        }
      }
    ).then(() => {
      this.props.showNotification('Association successful!');
    }).catch((err) => {
      let message = err.responseText && err.responseText !== '' ? err.responseText : 'An error occurred during the association.';
      if (err.status === 422) {
        let responseMsg = JSON.parse(err.responseText);
        message = '';
        for (var key in responseMsg) {
          message += responseMsg[key] + " ";
        }
      }
      this.props.showNotification(message);
    }).always(() => {
      this.props.refreshView();
    });
  }

  runSalesForceDissociation() {
    let sfDataIds = (this.props.ids || []).filter(id => {
      return this.props.data[id].label === 'salesforce';
    });

    $.ajax('/api/v1/job/sf/dissociate?mode=sync',
      {
        method: 'POST',
        data: {
          uuid: this.props.uuid,
          cid: this.props.data[sfDataIds[0]].data.contact_cid
        },
        headers: {
          Authorization: 'Bearer ' + get()
        }
      }
    ).then(() => {
      this.props.showNotification('Salesforce dissociation successful.');
    }).catch((err) => {
      let message = err.responseText && err.responseText !== '' ? err.responseText : 'An error occurred during the dissociation.';

      if (err.status === 422) {
        let responseMsg = JSON.parse(err.responseText);
        message = '';
        for (let key in responseMsg) {
          message += responseMsg[key] + " ";
        }
      }
      this.props.showNotification(message);
    }).always(() => {
      this.props.refreshView();
    });
  }

  pullSalesForceData() {
    this.setState({ refreshPending: true });

    let sfDataIds = (this.props.ids || []).filter(id => {
      return this.props.data[id].label === 'salesforce';
    });
    let contactId = this.props.data[sfDataIds[0]].data.contact_cid;

    if (contactId) {
      $.ajax('/api/v1/job/sf/manually-associate?mode=sync',
        {
          method: 'POST',
          data: {
            uuid: this.props.uuid,
            cid: contactId,
          },
          headers: {
            Authorization: 'Bearer ' + get()
          }
        }
      ).then(() => {
        this.props.showNotification('SalesForce data refresh successful.');
      }).catch((err) => {
        let message = err.responseText && err.responseText !== '' ? err.responseText : 'An error occurred during the data refresh.';

        if (err.status === 422) {
          let responseMsg = JSON.parse(err.responseText);
          message = '';
          for (let key in responseMsg) {
            message += responseMsg[key] + " ";
          }
        }
        this.props.showNotification(message);
      }).always(() => {
        this.setState({ refreshPending: false });
        this.props.refreshView();
      });
    } else {
      this.props.showNotification('Unable to refresh data. Contact Id can not be found.');
    }
  }
}

let ConnectedSalesForceEnabler = connect(null, { refreshView: refreshViewAction, showNotification: showNotificationAction })(SalesForceEnabler);

class SalesforceManager extends Component {
  render() {
    return <Card key="association" style={authCardStyle}>
      <CardHeader title="Salesforce Association" subheader="Manage the associated and activated Salesforce contact" />
      <CardContent>
        <ReferenceManyField filter={{label: 'salesforce'}} label={null} reference="info" target="auth_id" {...this.props}>
          <ConnectedSalesForceEnabler uuid={this.props.record.uuid} />
        </ReferenceManyField>
      </CardContent>
    </Card>;

  }
}

export default SalesforceManager;


// WEBPACK FOOTER //
// ./resources/assets/js/SalesforceTools.js